import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { getInstructors } from "../../State/Instructor/Action";
import AppPagination from "../Tools/AppPagination";
import { FaChalkboardTeacher } from "react-icons/fa";
import { generateSlug } from "../Constant/Utils";
import { useNavigate } from "react-router-dom";

const InstructorList = () => {
  const dispatch = useDispatch();
  const instructors = useSelector(
    (store) => store.instructor.instructors?.data?.instructors || []
  );
  const totalPages = useSelector(
    (store) => store.instructor.instructors?.data?.totalPages || 1
  );

  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(getInstructors(page));
  }, [dispatch, page]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-pink-50 to-white py-12 px-6">
      <motion.h1
        className="text-4xl font-extrabold text-center text-indigo-700 mb-10"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        🌟 Meet Our Top Instructors
      </motion.h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {instructors.map((inst) => (
          <motion.div
            key={inst.instructorId}
            className="bg-white rounded-3xl shadow-lg p-6 flex flex-col items-center hover:shadow-2xl transition"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <motion.img
              src={inst.instructorProfilePictureUrl}
              alt={inst.instructorName}
              className="w-24 h-24 rounded-full object-cover border-4 border-pink-400 mb-4"
              whileHover={{ scale: 1.05 }}
            />
            <h2
              className="text-xl font-bold text-indigo-700 mb-1 flex items-center cursor-pointer"
              onClick={() =>
                navigate(
                  `/instructors/${inst.instructorId}/${generateSlug(
                    inst.instructorName
                  )}`
                )
              }
            >
              <FaChalkboardTeacher className="mr-2 text-pink-500" />{" "}
              {inst.instructorName}
            </h2>
            <p className="text-gray-600 text-center italic mb-4">
              {inst.headline}
            </p>
          </motion.div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="mt-12 flex justify-center">
          <AppPagination setPage={setPage} totalPages={totalPages} />
        </div>
      )}
    </div>
  );
};

export default InstructorList;
